// Framework and third-party non-ui
import React, { useContext, useState, useEffect } from 'react';
import { loadModules } from 'esri-loader';
import { makeStyles } from '@material-ui/core/styles';

// App components
import { TripHistoryCard } from 'components/TrailCard';
import { UserContext } from 'contexts/UserContext';
import { MapContext } from 'contexts/MapContext';
import DeleteAllTripsAlert from './DeleteAllTripsAlert';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

// JSON & Styles
import { StyledNoResults } from './TrailsList-styled';

// Third-party components (buttons, icons, etc.)
import { Virtuoso } from 'react-virtuoso'
import AutoSizer from 'react-virtualized-auto-sizer';

const useStyles = makeStyles({
  tripInfoFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px 40px',
  },
  numberTrips: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  deleteAllTrips: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#B52626',
    cursor: 'pointer',
  },
  pointer: {
    cursor: 'pointer',
  },
  backArrowFlex: {
    display: 'flex',
    fontSize: '16px',
    width: '80%',
    margin: '15px',
  },
  header: {
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
    marginLeft: '15px',
  },
});

export default function TripsList ({}) {
  const { userInfo } = useContext(UserContext);
  const { setSidebarSelection } = useContext(MapContext);
  const [ deleteAllTripsAlertOpen, setDeleteAllTripsAlertOpen ] = useState(false);
  const [ tripHistory, setTripHistory ] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    (async () => {
      setTripHistoryInfo();
    })();
  }, [])

  const setTripHistoryInfo = async () => {
    const [esriRequest] = await loadModules(['esri/request']);
  
    let res = await esriRequest(userInfo.tripHistoryUrl + '/query',{
      method: 'post',
      query: {
        where: '1=1',
        outFields: '*',
        f:"json" // format
      },
     });

     setTripHistory(res.data.features.sort((a,b) => b.attributes.StartDateTime - a.attributes.StartDateTime));
  };

  if (!tripHistory.length) return (<StyledNoResults>No Trips Recorded</StyledNoResults>);

  const getTripHistoryInfo = () => {
    if(tripHistory.length === 1){
      return (
        <div className={classes.numberTrips}>{`${tripHistory.length} Trip`}</div>
      )
    }
    return (
      <div className={classes.numberTrips}>{`${tripHistory.length} Trips`}</div>
    )
  };

  const getDeleteAllTrips = () => {
    return (
      <div className={classes.deleteAllTrips} onClick={handleDeleteAllTripsAlertOpen}>Delete All Trips</div>
    )
  };

  const handleDeleteAllTripsAlertOpen = () => {
    setDeleteAllTripsAlertOpen(true);
  };

  const handleDeleteAllTripsAlertClose = () => {
    setDeleteAllTripsAlertOpen(false);
  };

  const deleteAllTrips = async () => {
    const [esriRequest] = await loadModules(['esri/request']);
    setDeleteAllTripsAlertOpen(false);
    const objectIds = tripHistory.map(feature => feature.attributes.OBJECTID);
    await esriRequest(userInfo.tripHistoryUrl + '/applyEdits',{
      method: 'post', // POST request
      query: {
          deletes: JSON.stringify(objectIds),
          f:"json" // format
      },
    }).then((r) => {
        setTripHistory([]);
    }).catch((e) => {
        console.log(e);
        alert('Failed to delete, please try again');
    });
  };

  const goBackToProfile = () => {
    setSidebarSelection(['Profile']);
  };

  const Row = (index) => {
    if(tripHistory[index] && tripHistory[index].attributes){
      const attributes = tripHistory[index].attributes;
      const geometry = tripHistory[index].geometry;
      return (
        <TripHistoryCard
          feature={tripHistory[index]}
          key={attributes.OBJECTID}
          attributes={attributes}
          geometry={geometry}
          loggedIn={userInfo ? true:  false}
        />
      );
    }
  };


  return (
    <>
      <div className={classes.backArrowFlex} >
        <ArrowBackIcon className={classes.pointer} onClick={() => {goBackToProfile()}}></ArrowBackIcon>
        <div className={classes.header}>Recorded Trips</div>
      </div>
      <div className={classes.tripInfoFlex}>
        {getTripHistoryInfo()}
        {getDeleteAllTrips()}
      </div>
      <AutoSizer>
        {({ width, height }) => (
          <Virtuoso
            style={{ width, height }}
            totalCount={tripHistory.length}
            item={Row}
            overscan={500}
          >
          </Virtuoso>
        )}
      </AutoSizer>
      <DeleteAllTripsAlert deleteAlertOpen={deleteAllTripsAlertOpen} setDeleteTripAlertClose={handleDeleteAllTripsAlertClose} deleteAllTrips={deleteAllTrips}/>
    </>
  );
};